import { Component,ChangeDetectorRef,ChangeDetectionStrategy, OnChanges, SimpleChanges, ElementRef, OnInit, Input, ViewChild, HostListener } from '@angular/core';
import { GoogledrivefilterdataComponent } from '../../popups/Googledrivefilterdata/Googledrivefilterdata.component';
import { GoogledetailsComponent } from '../../popups/Googledetails/Googledetails.component';
//import fs from '../../../../../node_modules/@types/node'
import PouchDB from 'pouchdb';
import PouchdbFind from 'pouchdb-find';
import { StorePouchDb } from '../../../store/store.pouchdb.service';
import { Http, Response, RequestOptions, Headers, RequestOptionsArgs } from '@angular/http';

import {
  Ng4FilesService,
  Ng4FilesConfig,
  Ng4FilesStatus,
  Ng4FilesSelected
} from '../../Clouddata/ng4-files'
import * as _ from 'lodash';
import { GoogleService } from '../../../shared/Google.service';
import { Ng2OrderModule } from 'ng2-order-pipe';
import { OrderbyPipe } from './../../Orderby.pipe';
import { debuglog } from 'util';
import { NewFolderDialog } from '../../mycontent/mycontent.component';

import { ENETUNREACH } from 'constants';
import { IS_ElectronService } from '../../../../../src/app/shared/IS_Electron.service';
import { build$ } from 'protractor/built/element';

// declare var fstream:any;
declare var FilePicker: any;
declare var filesdata: any;
declare var google;
declare var gapi: any;
declare var google: any;
declare var childreandata: any;
declare var cdata: any;
declare var MediaUploader: any;
//var fs = require('browserify-fs');


interface Ipopupconfig {
  height: number,
  width: number,
  direction: string,
  arrowPos: number,
  showPopup: boolean,
  loadDirective: any,
  isBooksFilter: string
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-googledrive',
  templateUrl: './googledrive.component.html',
  styleUrls: ['./googledrive.component.css']
  
})

export class GoogledriveComponent implements OnInit {
  @Input() data: any;
  @ViewChild('fileInput') fileInputVariable: any;

  @ViewChild('bottomThumbs', { read: ElementRef }) public panel: ElementRef;
  @ViewChild('bottomThumbs1', { read: ElementRef }) public bottomThumbs1: ElementRef;
  @ViewChild('bottomThumbs2', { read: ElementRef }) public bottomThumbs2: ElementRef;
  @ViewChild('bottomThumbshare', { read: ElementRef }) public bottomThumbshare: ElementRef;
  @ViewChild('bottomThumbsfilter', { read: ElementRef }) public bottomThumbsfilter: ElementRef;
  @ViewChild('bottomThumbsFolderdata', { read: ElementRef }) public bottomThumbsFolderdata: ElementRef;
  @ViewChild('bottomThumbsFilesdata', { read: ElementRef }) public bottomThumbsFilesdata: ElementRef;

  @HostListener('window:resize') onResize() {
    try {
      this.availableWidth = this.panel.nativeElement.offsetWidth;
    }
    catch (ex) {

    }
    try {
      this.availableWidth = this.bottomThumbs1.nativeElement.offsetWidth;
    }
    catch (ex) {

    }
    try {
      this.availableWidth = this.bottomThumbs2.nativeElement.offsetWidth;
    }
    catch (ex) {

    }
    try {
      this.availableWidth = this.bottomThumbshare.nativeElement.offsetWidth;
    }
    catch (ex) {

    }

    this.updateAllScrollableElements()
    this.chRef.detectChanges()
  }

  globalPopupPara = <any>{};
  public GoogledriveData;
  public files: Array<any>
  public popDirection = ['type1', 'type2', 'type3'];
  public GoogleData = ['Recent', 'Folder', 'Files']
  public drive;
  public googlechilderen;
  public storedata = [];
  public fdata = [];
  showFoldernextPrev = false;
  public droppedFile;
  public isrootid = [];
  isrootfileid = []
  isrootfolderid = [];
  hideline;
  public currentHoverEle;
  public IsFilterdata = false
  public hideArrowButtons: boolean = false;
  public ishowfloderscroll: boolean = false;
  public ishowfilesscroll: boolean = false;
  public sharewithmedata: any;
  selGoogleDetals;
  isShowsharewithme;
  SelectedSubType;
  ishowFolderdatascroll = false;
  ishowFilesdatascroll = false;
  ishowsharescroll = false
  ishowfilterscroll = false
  apiKey: string;
  SharingUser = []
  Clientid: string
  picker: any;
  counter = Array;
  mimetype: string;
  hidedata = false;
  Math: any;
  availableViewableWidth = 20;
  popupParams = {
    height: 400,
    width: 300,
    direction: "left",
    arrowPos: 50,
    showPopup: false,
    isBooksFilter: "country",
    curComp: this

  };
  public IsFolderdata = false;


  public availableWidthshare = 20;
  public availableWidth = 20;
  hideRecentNext = false;
  hideFolderNext = false;
  hideShareNext = false;
  hideFolderfNext = false;
  hideFilefNext = false;
  hideFilterNext = false
  hideFilePrev = true
  hideSharePrev = true
  hideFolderfPrev = true;
  hideFilterPrev = true;
  hideFilefPrev = true;
  hideFileNext = false
  hideFolderPrev = true;
  hideRecentPrev = true;
  public gridToggleIcon = 'icon-BottomButton';
  showRecentsGrid = false;
  showFoldersGrid = false;
  showFiledatasGrid = false
  showFiltersGrid = false
  showFilesGrid = false;
  showSharesGrid = false;
  showFolderdatasGrid = false;
  bookPath: string
  filesize: any
  remoteDB;
  localDB;
  showRectd
  showfold;
  showfiled;

  isUserLoggedIn = false;

  constructor(private chRef: ChangeDetectorRef, private ele: ElementRef, private google: GoogleService, public pouchservice: StorePouchDb, private http: Http, private ElectronService: IS_ElectronService) {
    this.Math = Math
    PouchDB.plugin(PouchdbFind);
  }

  ngOnInit() {

    this.data.this.drivedata = this;
    this.data.pouchData.myderive.mydrivedata = this;

    if (localStorage.userData !=undefined && localStorage.userData != 'undefined') {
      this.isUserLoggedIn = true
    }
    //var bookPath = 'assets/Nooor/Media.zip';
    // if(this.ElectronService.FS.existsSync(bookPath)){
    //   console.log("dsadyft")
    // }
    if (this.ElectronService.IS_ELECTRON){
      // this.showfold=true;
      // this.showRectd=true
      // this.showfiled=true

      this.chRef.detectChanges();
    }

    document['googledrivethis'] = this;

    gapi.load('client', {
      callback: function () {

      },
      onerror: function () {
        // Handle loading error.
        alert('gapi.client failed to load!');
      },
      timeout: 5000, // 5 seconds.
      ontimeout: function () {

        // Handle timeout.ng
        alert('gapi.client could not load in a timely manner!');
      }



    });

    // this.ele.nativeElement.querySelector('.lds-roller').style.display = '';
    // if(this.isrootfolderid.length>0 && this.isrootfileid.length>0 && this.GoogledriveData!=undefined){
    //   this.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';


    //   this.showfiled=true
    // }
    // else{
    //   this.ele.nativeElement.querySelector('.lds-roller').style.display = '';
    // }

    var request = gapi.client.drive.files.get({ 'fileId': localStorage.currentDriveMediaId });
    // that.isrootfileid=[]
    request.execute(function (resp) {
      console.log(resp)
    })




    if (!this.GoogledriveData) {
      this.Getgoogledrive(this);
    }

    this.Getfolderdtaledrive(this)

    this.Getfilesdtaledrive(this)

    this.isShowsharewithme = this.data.this.sharedWithMe;
    this.Getsharegoogledrive(this);

  }

  ngDoCheck() {

    if(this.isrootfolderid.length>0 && this.isrootfileid.length>0 && this.GoogledriveData!=undefined){
      this.showfold=true;
      this.showRectd=true
      this.showfiled=true

     if (this.ElectronService.IS_ELECTRON){
       this.chRef.detectChanges();
     }
    }


  }

  ngOnDestroy() {
    this.chRef.detach();
  }
    ngAfterViewChecked() {
    // try {
    //   this.availableWidth = this.panel.nativeElement.offsetWidth;
    // }
    // catch (ex) {

    // }
    // try {
    //   this.availableWidth = this.bottomThumbs1.nativeElement.offsetWidth;
    // }
    // catch (ex) {

    // }
    // try {
    //   this.availableWidth = this.bottomThumbs2.nativeElement.offsetWidth;
    // }
    // catch (ex) {

    // }
    // try {
    //   this.availableWidth = this.bottomThumbshare.nativeElement.offsetWidth;
    // }
    // catch (ex) {

    // }
    if(this.panel){
      this.availableWidth = this.panel.nativeElement.offsetWidth;
    }else if(this.bottomThumbs1){
      this.availableWidth = this.bottomThumbs1.nativeElement.offsetWidth;
    }else if(this.bottomThumbs2){
      this.availableWidth = this.bottomThumbs2.nativeElement.offsetWidth;
    }else if(this.bottomThumbshare){
      this.availableWidth = this.bottomThumbshare.nativeElement.offsetWidth;
    }
    
      this.chRef.detectChanges();
   
  }


  filtergroup
  filterdata(value) {
    this.mimetype = value;
    if (value != 'image')
      this.filtergroup = _.filter(this.GoogledriveData, function (o) { return o.mimeType == value && o.labels.trashed == false; });
    else
      this.filtergroup = _.filter(this.GoogledriveData, function (o) { return (o.mimeType == "image/jpeg" || o.mimeType == "image/png" || o.mimeType == "image/bmp") && o.labels.trashed == false; });
    // alert(this.mimetype)
    if (value != 'all') {
      this.IsFilterdata = true;
    }
    else {
      this.IsFilterdata = false;
    }



  }


  selectedFiles
  parentid
  public filesSelect(selectedFiles: Ng4FilesSelected): void {
    if (selectedFiles.status !== Ng4FilesStatus.STATUS_SUCCESS) {
      this.selectedFiles = selectedFiles.status;
      return;
    }
    if (this.fdata.length > 0) {

      var r = this.fdata.length - 1
      this.parentid = this.fdata[r].id
    }
    this.google.insertFileintodrive(selectedFiles.files[0], selectedFiles.files, this.parentid, this)
    // Handle error statuses here

    this.selectedFiles = Array.from(selectedFiles.files).map(file => file.name);
  }

  updatingDriveView(){
    this.chRef.detectChanges();
    this.chRef.detach();
  }

  getAllFolderData(data) {
    this.GoogledriveData = data;
  }


  mouseEnter(type: string, event, index) {

    this.currentHoverEle = event.target;
    if (type == "Recent") {
      if (this.panel.nativeElement.scrollWidth > this.panel.nativeElement.offsetWidth) {
        // this.hideArrowButtons = true;
      }
      
    }

    if (type == "Folder") {
      if (this.bottomThumbs1.nativeElement.scrollWidth > this.bottomThumbs1.nativeElement.offsetWidth) {
        // this.ishowfloderscroll = true;

      }

    }
    if (type == "Files") {
      if (this.bottomThumbs2.nativeElement.scrollWidth > this.bottomThumbs2.nativeElement.offsetWidth) {
        this.ishowfilesscroll = true;
     
      }
    }
    if (type == "share") {
      if (this.bottomThumbshare.nativeElement.scrollWidth > this.bottomThumbshare.nativeElement.offsetWidth) {
        this.ishowsharescroll = true;
      }
   
    }

    if (type == "filter") {
      if (this.bottomThumbsfilter.nativeElement.scrollWidth > this.bottomThumbsfilter.nativeElement.offsetWidth) {
        this.ishowfilterscroll = true;
 
      }
    }
    if (type == "Folderdata") {
      if (this.bottomThumbsFolderdata.nativeElement.scrollWidth > this.bottomThumbsFolderdata.nativeElement.offsetWidth) {
        this.ishowFolderdatascroll = true;
     
      }
    }

    if (type == "Filesdata") {
      if (this.bottomThumbsFilesdata.nativeElement.scrollWidth > this.bottomThumbsFilesdata.nativeElement.offsetWidth) {
        this.ishowFilesdatascroll = true;
        
      }


    }

    this.chRef.detectChanges()
  }

  mouseLeave(type, event) {
    if (type == "Recent") {
      this.hideArrowButtons = false;
    }
    else if (type == "Folder") {
      this.ishowfloderscroll = false;
    }
    else if (type == "Files") {
      this.ishowfilesscroll = false;
    }
    else if (type == "filter") {
      this.ishowfilterscroll = false;
    }
    else if (type == "share") {
      this.ishowsharescroll = false;
    }
    else if (type == "Folderdata") {
      this.ishowFolderdatascroll = false;
    }
    else if (type == "Filesdata") {
      this.ishowFilesdatascroll = false;
    }
    // this.ishowfloderscroll = false;
    // this.ishowfilesscroll = false;
  }

  scrollThumbs(pos) {
    let dis;
    let temp;
    let clsList = this.ele.nativeElement.querySelector('.bottomthumViewbook').classList;
    // let scrollNavigation = this.panel.nativeElement.querySelectorAll('.booksNavigation');
    // let activeIndex;
    // for (let i = 0; i < scrollNavigation.length; i++) {
    //   if (scrollNavigation[i].classList.contains('activeScrollBar')) {
    //     activeIndex = i;
    //   }
    // }


    if (pos == "prev") {
      // if (!scrollNavigation[activeIndex - 2]) {
      //   this.hideRecentPrev = true;
      // }


      dis = this.panel.nativeElement.scrollLeft;
      temp = this.panel.nativeElement.scrollLeft - this.availableWidth;

if(temp <= 0){
  this.hideRecentPrev = true;
}

      if(!this.ElectronService.IS_ELECTRON){
        this.ele.nativeElement.querySelector('.bottomthumViewbook').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
      }
      else{
        this.ele.nativeElement.querySelector('.bottomthumViewbook').scrollLeft = temp;
      }

      // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
      // scrollNavigation[activeIndex - 1].classList.add('activeScrollBar');
    }
    else {
let tempEle = this.ele.nativeElement.querySelector('.bottomthumViewbook');
      let maxScrollLeftOfEle = tempEle.scrollWidth - tempEle.clientWidth;

      if (maxScrollLeftOfEle > tempEle.scrollLeft) {
        dis = this.panel.nativeElement.scrollLeft;
        temp = this.panel.nativeElement.scrollLeft + this.availableWidth;
        // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
        // scrollNavigation[activeIndex + 1].classList.add('activeScrollBar');

        if(!this.ElectronService.IS_ELECTRON){
          this.ele.nativeElement.querySelector('.bottomthumViewbook').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
        }else{
          this.ele.nativeElement.querySelector('.bottomthumViewbook').scrollLeft = temp
        }        
        this.hideRecentPrev = false;
      }
      else {
        // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
        // scrollNavigation[0].classList.add('activeScrollBar');
        if(!this.ElectronService.IS_ELECTRON){
          this.ele.nativeElement.querySelector('.bottomthumViewbook').scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }else{
          this.ele.nativeElement.querySelector('.bottomthumViewbook').scrollLeft = 0;
        }

        
        this.hideRecentPrev = true;
      }
    }
  }

  scrollThumbs1(pos) {
    let dis;
    let temp;
    let clsList = this.ele.nativeElement.querySelector('.bottomthumViewbook1').classList;
    // let scrollNavigation = this.bottomThumbs1.nativeElement.querySelectorAll('.booksNavigation');
    // let activeIndex;
    // for (let i = 0; i < scrollNavigation.length; i++) {
    //   if (scrollNavigation[i].classList.contains('activeScrollBar')) {
    //     activeIndex = i;
    //   }
    // }
    if (pos == "prev") {
      // if (!scrollNavigation[activeIndex - 2]) {
      //   this.hideFolderPrev = true;
      // }

      dis = this.bottomThumbs1.nativeElement.scrollLeft;
      temp = this.bottomThumbs1.nativeElement.scrollLeft - this.availableWidth;

      if(temp <= 0){
        this.hideFolderPrev = true;
      }

      if(!this.ElectronService.IS_ELECTRON){
        this.ele.nativeElement.querySelector('.bottomthumViewbook1').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
      }else{
        this.ele.nativeElement.querySelector('.bottomthumViewbook1').scrollLeft = temp;
      }

      

      // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
      // scrollNavigation[activeIndex - 1].classList.add('activeScrollBar');
    }
    else {
let tempEle = this.ele.nativeElement.querySelector('.bottomthumViewbook1');
      let maxScrollLeftOfEle = tempEle.scrollWidth - tempEle.clientWidth;

      if (maxScrollLeftOfEle > tempEle.scrollLeft) {
        dis = this.bottomThumbs1.nativeElement.scrollLeft;
        temp = this.bottomThumbs1.nativeElement.scrollLeft + this.availableWidth;
        // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
        // scrollNavigation[activeIndex + 1].classList.add('activeScrollBar');

        if(!this.ElectronService.IS_ELECTRON){
          this.ele.nativeElement.querySelector('.bottomthumViewbook1').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
        }else{
          this.ele.nativeElement.querySelector('.bottomthumViewbook1').scrollLeft = temp
        }

        
        this.hideFolderPrev = false;
      }
      else {
        // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
        // scrollNavigation[0].classList.add('activeScrollBar');

        if(!this.ElectronService.IS_ELECTRON){
          this.ele.nativeElement.querySelector('.bottomthumViewbook1').scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }else{
          this.ele.nativeElement.querySelector('.bottomthumViewbook1').scrollLeft = 0;
        }

        
        this.hideFolderPrev = true;
      }
    }
  }

  scrollThumbs2(pos) {

    let dis;
    let temp;
    let clsList = this.ele.nativeElement.querySelector('.bottomthumViewbook2').classList;
    // let scrollNavigation = this.bottomThumbs2.nativeElement.querySelectorAll('.booksNavigation');
    // let activeIndex;
    // for (let i = 0; i < scrollNavigation.length; i++) {
    //   if (scrollNavigation[i].classList.contains('activeScrollBar')) {
    //     activeIndex = i;
    //   }
    // }
    if (pos == "prev") {

      // if (!scrollNavigation[activeIndex - 2]) {
      //   this.hideFilePrev = true;
      // }

      dis = this.bottomThumbs2.nativeElement.scrollLeft;
      temp = this.bottomThumbs2.nativeElement.scrollLeft - this.availableWidth;
      if(temp <= 0){
        this.hideFilePrev = true;
      }

      if(!this.ElectronService.IS_ELECTRON){
        this.ele.nativeElement.querySelector('.bottomthumViewbook2').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
      }else{
        this.ele.nativeElement.querySelector('.bottomthumViewbook2').scrollLeft = temp;
      }

      
      // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
      // scrollNavigation[activeIndex - 1].classList.add('activeScrollBar');
    }
    else {

      let tempEle = this.ele.nativeElement.querySelector('.bottomthumViewbook2');
      let maxScrollLeftOfEle = tempEle.scrollWidth - tempEle.clientWidth;

      if (maxScrollLeftOfEle > tempEle.scrollLeft) {
        dis = this.bottomThumbs2.nativeElement.scrollLeft;
        temp = this.bottomThumbs2.nativeElement.scrollLeft + this.availableWidth;
        // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
        // scrollNavigation[activeIndex + 1].classList.add('activeScrollBar');

        if(!this.ElectronService.IS_ELECTRON){
          this.ele.nativeElement.querySelector('.bottomthumViewbook2').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
        }else{
          this.ele.nativeElement.querySelector('.bottomthumViewbook2').scrollLeft = temp;
        }

        
        this.hideFilePrev = false;
      }
      else {
        // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
        // scrollNavigation[0].classList.add('activeScrollBar');

        if(!this.ElectronService.IS_ELECTRON){
          this.ele.nativeElement.querySelector('.bottomthumViewbook2').scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }else{
          this.ele.nativeElement.querySelector('.bottomthumViewbook2').scrollLeft = 0
        }
        
        this.hideFilePrev = true;
      }
    }
  }



  updateAllScrollableElements(){
    if(this.ele.nativeElement.querySelector('.bottomthumViewbookshare'))
    this.ele.nativeElement.querySelector('.bottomthumViewbookshare').scrollLeft = 0;

    if(this.ele.nativeElement.querySelector('.bottomThumbsfilters'))
    this.ele.nativeElement.querySelector('.bottomThumbsfilters').scrollLeft = 0;

    if(this.ele.nativeElement.querySelector('.bottomthumViewbookFolderdatas'))
    this.ele.nativeElement.querySelector('.bottomthumViewbookFolderdatas').scrollLeft = 0;

    if(this.ele.nativeElement.querySelector('.bottomthumViewbookFilesdatas'))
    this.ele.nativeElement.querySelector('.bottomthumViewbookFilesdatas').scrollLeft = 0;

    if(this.ele.nativeElement.querySelector('.bottomthumViewbook'))
    this.ele.nativeElement.querySelector('.bottomthumViewbook').scrollLeft = 0;

    if(this.ele.nativeElement.querySelector('.bottomthumViewbook1'))
    this.ele.nativeElement.querySelector('.bottomthumViewbook1').scrollLeft = 0;

    if(this.ele.nativeElement.querySelector('.bottomthumViewbook2'))
    this.ele.nativeElement.querySelector('.bottomthumViewbook2').scrollLeft = 0;
    
    
  
  }



  scrollThumbshare(pos) {

    let dis;
    let temp;
    let clsList = this.ele.nativeElement.querySelector('.bottomthumViewbookshare').classList;
    // let scrollNavigation = this.bottomThumbshare.nativeElement.querySelectorAll('.booksNavigation');
    // let activeIndex;
    // for (let i = 0; i < scrollNavigation.length; i++) {
    //   if (scrollNavigation[i].classList.contains('activeScrollBar')) {
    //     activeIndex = i;
    //   }
    // }
    if (pos == "prev") {
      // if (!scrollNavigation[activeIndex - 2]) {
      //   this.hideSharePrev = true;
      // }

      dis = this.bottomThumbshare.nativeElement.scrollLeft;
      temp = this.bottomThumbshare.nativeElement.scrollLeft - this.availableWidth;

      if(temp <= 0){
        this.hideSharePrev = true;
      }

      if(!this.ElectronService.IS_ELECTRON){
        this.ele.nativeElement.querySelector('.bottomthumViewbookshare').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
      }else{
        this.ele.nativeElement.querySelector('.bottomthumViewbookshare').scrollLeft = temp;
      }
      
      // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
      // scrollNavigation[activeIndex - 1].classList.add('activeScrollBar');
    }
    else {
      let tempEle = this.ele.nativeElement.querySelector('.bottomthumViewbookshare');
      let maxScrollLeftOfEle = tempEle.scrollWidth - tempEle.clientWidth;

      if (maxScrollLeftOfEle > tempEle.scrollLeft) {
        dis = this.bottomThumbshare.nativeElement.scrollLeft;
        temp = this.bottomThumbshare.nativeElement.scrollLeft + this.availableWidth;
        // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
        // scrollNavigation[activeIndex + 1].classList.add('activeScrollBar');
        if(!this.ElectronService.IS_ELECTRON){
          this.ele.nativeElement.querySelector('.bottomthumViewbookshare').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
        }else{
          this.ele.nativeElement.querySelector('.bottomthumViewbookshare').scrollLeft = temp
        }
        
        this.hideSharePrev = false;
      }
      else {
        // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
        // scrollNavigation[0].classList.add('activeScrollBar');
        if(!this.ElectronService.IS_ELECTRON){
          this.ele.nativeElement.querySelector('.bottomthumViewbookshare').scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }else{
          this.ele.nativeElement.querySelector('.bottomthumViewbookshare').scrollLeft = 0;
        }
        
        this.hideSharePrev = true;
      }
    }
  }

  scrollThumbfilter(pos) {
    // let dis;
    // let temp;
    // let clsList = this.ele.nativeElement.querySelector('.bottomThumbsfilters').classList;
    // if (pos == "prev") {
    //   dis = this.bottomThumbsfilter.nativeElement.scrollLeft;
    //   temp = this.bottomThumbsfilter.nativeElement.scrollLeft + 500;
    //   this.ele.nativeElement.querySelector('.bottomThumbsfilters').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
    // }
    // else {
    //   dis = this.bottomThumbsfilter.nativeElement.scrollLeft;
    //   temp = this.bottomThumbsfilter.nativeElement.scrollLeft - 500;
    //   this.ele.nativeElement.querySelector('.bottomThumbsfilters').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
    // }

    let dis;
    let temp;
    let clsList = this.ele.nativeElement.querySelector('.bottomThumbsfilters').classList;
    // let scrollNavigation = this.bottomThumbsfilter.nativeElement.querySelectorAll('.booksNavigation');
    // let activeIndex;
    // for (let i = 0; i < scrollNavigation.length; i++) {
    //   if (scrollNavigation[i].classList.contains('activeScrollBar')) {
    //     activeIndex = i;
    //   }
    // }
    if (pos == "prev") {
      // if (!scrollNavigation[activeIndex - 2]) {
      //   this.hideFilterPrev = true;
      // }

      dis = this.bottomThumbsfilter.nativeElement.scrollLeft;
      temp = this.bottomThumbsfilter.nativeElement.scrollLeft - this.availableWidth;

      if(temp <= 0){
        this.hideFilterPrev = true;
      }

      if(!this.ElectronService.IS_ELECTRON){
        this.ele.nativeElement.querySelector('.bottomThumbsfilters').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
      }else{
        this.ele.nativeElement.querySelector('.bottomThumbsfilters').scrollLeft = temp;
      }

      
      // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
      // scrollNavigation[activeIndex - 1].classList.add('activeScrollBar');
    }
    else {
      let tempEle = this.ele.nativeElement.querySelector('.bottomThumbsfilters');
      let maxScrollLeftOfEle = tempEle.scrollWidth - tempEle.clientWidth;

      if (maxScrollLeftOfEle > tempEle.scrollLeft) {
        dis = this.bottomThumbsfilter.nativeElement.scrollLeft;
        temp = this.bottomThumbsfilter.nativeElement.scrollLeft + this.availableWidth;
        // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
        // scrollNavigation[activeIndex + 1].classList.add('activeScrollBar');
        if(!this.ElectronService.IS_ELECTRON){
          this.ele.nativeElement.querySelector('.bottomThumbsfilters').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
        }else{
          this.ele.nativeElement.querySelector('.bottomThumbsfilters').scrollLeft = temp;
        }
        
        this.hideFilterPrev = false;
      }
      else {
        // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
        // scrollNavigation[0].classList.add('activeScrollBar');
        if(!this.ElectronService.IS_ELECTRON){
          this.ele.nativeElement.querySelector('.bottomThumbsfilters').scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }else{
          this.ele.nativeElement.querySelector('.bottomThumbsfilters').scrollLeft = 0
        }
        
        this.hideFilterPrev = true;
      }
    }
  }

  scrollThumbsFolderdata(pos) {
    // let dis;
    // let temp;
    // let clsList = this.ele.nativeElement.querySelector('.bottomthumViewbookFolderdatas').classList;
    // if (pos == "prev") {
    //   dis = this.bottomThumbsFolderdata.nativeElement.scrollLeft;
    //   temp = this.bottomThumbsFolderdata.nativeElement.scrollLeft + 500;
    //   this.ele.nativeElement.querySelector('.bottomthumViewbookFolderdatas').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
    // }
    // else {
    //   dis = this.bottomThumbsFolderdata.nativeElement.scrollLeft;
    //   temp = this.bottomThumbsFolderdata.nativeElement.scrollLeft - 500;
    //   this.ele.nativeElement.querySelector('.bottomthumViewbookFolderdatas').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
    // }

    let dis;
    let temp;
    let clsList = this.ele.nativeElement.querySelector('.bottomthumViewbookFolderdatas').classList;
    // let scrollNavigation = this.bottomThumbsFolderdata.nativeElement.querySelectorAll('.booksNavigation');
    // let activeIndex;
    // for (let i = 0; i < scrollNavigation.length; i++) {
    //   if (scrollNavigation[i].classList.contains('activeScrollBar')) {
    //     activeIndex = i;
    //   }
    // }
    if (pos == "prev") {
      // if (!scrollNavigation[activeIndex - 2]) {
      //   this.hideFolderfPrev = true;
      // }

      dis = this.bottomThumbsFolderdata.nativeElement.scrollLeft;
      temp = this.bottomThumbsFolderdata.nativeElement.scrollLeft - this.availableWidth;

      if(temp <= 0){
        this.hideFolderfPrev = true;
      }

      if(!this.ElectronService.IS_ELECTRON){
        this.ele.nativeElement.querySelector('.bottomthumViewbookFolderdatas').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
      }else{
        this.ele.nativeElement.querySelector('.bottomthumViewbookFolderdatas').scrollLeft = temp
      }
      
      // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
      // scrollNavigation[activeIndex - 1].classList.add('activeScrollBar');
    }
    else {

      let tempEle = this.ele.nativeElement.querySelector('.bottomthumViewbookFolderdatas');
      let maxScrollLeftOfEle = tempEle.scrollWidth - tempEle.clientWidth;

      if (maxScrollLeftOfEle > tempEle.scrollLeft) {
        dis = this.bottomThumbsFolderdata.nativeElement.scrollLeft;
        temp = this.bottomThumbsFolderdata.nativeElement.scrollLeft + this.availableWidth;
        // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
        // scrollNavigation[activeIndex + 1].classList.add('activeScrollBar');

        if(!this.ElectronService.IS_ELECTRON){
          this.ele.nativeElement.querySelector('.bottomthumViewbookFolderdatas').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
        }else{
          this.ele.nativeElement.querySelector('.bottomthumViewbookFolderdatas').scrollLeft = temp
        }

        
        this.hideFolderfPrev = false;
      }
      else {
        // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
        // scrollNavigation[0].classList.add('activeScrollBar');

        if(!this.ElectronService.IS_ELECTRON){
          this.ele.nativeElement.querySelector('.bottomthumViewbookFolderdatas').scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }else{
          this.ele.nativeElement.querySelector('.bottomthumViewbookFolderdatas').scrollLeft =0
        }

        
        this.hideFolderfPrev = true;
      }
    }
  }

  scrollThumbsFilesdata(pos) {

    let dis;
    let temp;
    let clsList = this.ele.nativeElement.querySelector('.bottomthumViewbookFilesdatas').classList;
    // let scrollNavigation = this.bottomThumbsFilesdata.nativeElement.querySelectorAll('.booksNavigation');
    // let activeIndex;
    // for (let i = 0; i < scrollNavigation.length; i++) {
    //   if (scrollNavigation[i].classList.contains('activeScrollBar')) {
    //     activeIndex = i;
    //   }
    // }
    if (pos == "prev") {
      // if (!scrollNavigation[activeIndex - 2]) {
      //   this.hideFilefPrev = true;
      // }

      dis = this.bottomThumbsFilesdata.nativeElement.scrollLeft;
      temp = this.bottomThumbsFilesdata.nativeElement.scrollLeft - this.availableWidth;

      if(temp <= 0){
        this.hideFilefPrev = true;
      }

      if(!this.ElectronService.IS_ELECTRON){
        this.ele.nativeElement.querySelector('.bottomthumViewbookFilesdatas').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
      }else{
        this.ele.nativeElement.querySelector('.bottomthumViewbookFilesdatas').scrollLeft = temp
      }
      
      // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
      // scrollNavigation[activeIndex - 1].classList.add('activeScrollBar');
    }
    else {

      let tempEle = this.ele.nativeElement.querySelector('.bottomthumViewbookFilesdatas');
      let maxScrollLeftOfEle = tempEle.scrollWidth - tempEle.clientWidth;

      if (maxScrollLeftOfEle > tempEle.scrollLeft) {
        dis = this.bottomThumbsFilesdata.nativeElement.scrollLeft;
        temp = this.bottomThumbsFilesdata.nativeElement.scrollLeft + this.availableWidth;
        // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
        // scrollNavigation[activeIndex + 1].classList.add('activeScrollBar');

        if(!this.ElectronService.IS_ELECTRON){
          this.ele.nativeElement.querySelector('.bottomthumViewbookFilesdatas').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
        }else{
          this.ele.nativeElement.querySelector('.bottomthumViewbookFilesdatas').scrollLeft = temp;
        }

       
        this.hideFilefPrev = false;
      }
      else {
        // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
        // scrollNavigation[0].classList.add('activeScrollBar');
        if(!this.ElectronService.IS_ELECTRON){
          this.ele.nativeElement.querySelector('.bottomthumViewbookFolderdatas').scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }else{
          this.ele.nativeElement.querySelector('.bottomthumViewbookFolderdatas').scrollLeft = 0;
        }

        
        this.hideFilefPrev = true;
      }
    }
    // let dis;
    // let temp;
    // let clsList = this.ele.nativeElement.querySelector('.bottomthumViewbookFilesdatas').classList;
    // if (pos == "prev") {
    //   dis = this.bottomThumbsFilesdata.nativeElement.scrollLeft;
    //   temp = this.bottomThumbsFilesdata.nativeElement.scrollLeft + 500;
    //   this.ele.nativeElement.querySelector('.bottomthumViewbookFilesdatas').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
    // }
    // else {
    //   dis = this.bottomThumbsFilesdata.nativeElement.scrollLeft;
    //   temp = this.bottomThumbsFilesdata
    //     .nativeElement.scrollLeft - 500;
    //   this.ele.nativeElement.querySelector('.bottomthumViewbookFilesdatas').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
    // }
  }

  Returntosameplace() {
    // this.chRef.detectChanges();
    //this.Getgoogledrive(this)
    this.IsFolderdata = false;
    this.fdata = [];
    this.showfiles = false
    this.showfoler = false
    this.IsFilterdata = false

    // this.GoogledriveData.forEach(function (_data) {
    //   _data.embedLink=_data.iconLink.replace(/16/g,128)

    // });

    // this.chRef.detectChanges();
  }

  Getsharegoogledrive(self) {

    let that = this;

    // var request = gapi.client.people.people.connections.list({
    //   resourceName: 'people/me',
    //   personFields: 'emailAddresses,names'

    // })

    // request.execute(function (resp) {

    //   console.log(resp)
    // })
    try {
      var request = gapi.client.drive.files.list({
        q: "trashed=false and sharedWithMe=true",
        //fields: "nextPageToken, files(id,title,webContentLink,webViewLink,mimeType,description,thumbnailLink,parents,iconLink,kind,sharingUser,shared,sharedWithMeTime)"

      });

      request.execute(function (resp) {
        if (!resp.error) {
          that.showwallsharefile = _.filter(resp.items, function (o) { return o.labels.trashed == false; });
          that.sharewithmedata = _.filter(resp.items, function (o) { return o.labels.trashed == false; });

          if (that.sharewithmedata != undefined) {
            that.sharewithmedata.forEach(function (_data) {
              _data.embedLink = _data.iconLink.replace(/16/g, 128)



              var name = _data.ownerNames
              if (that.SharingUser.indexOf(name[0]) == -1) {
                that.SharingUser.push(name[0])
              }



            });
          }
          //   that.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
        }
      })
    } catch (ex) {

    }


  }
  myfile
  getaldata
  getfiledata
  showwallsharefile = []
  filtersharedata(name) {

    this.sharewithmedata = this.showwallsharefile

    if (name != 'All') {


      this.sharewithmedata = _.filter(this.sharewithmedata, function (o) {
        return o.ownerNames[0] == name;
      });

    }
    else {
      this.sharewithmedata = this.showwallsharefile
    }
    this.globalPopupPara = this.popupParams;
    this.globalPopupPara.showPopup = false;
  }
  Getfilesdtaledrive(self) {
    let that = this;
    try {
      var request = gapi.client.drive.files.list({
        q: "trashed=false and mimeType!='application/vnd.google-apps.folder'",
        'maxResults': 1000

      });
      // this.ele.nativeElement.querySelector('.lds-roller').style.display = '';
      request.execute(function (resp) {
        if (!resp.error) {
          that.getfiledata = resp.items;

          that.getfileroot(that, resp.items);


          if (that.getfiledata != undefined) {
            that.getfiledata.forEach(function (_data) {
              _data.embedLink = _data.iconLink.replace(/16/g, 128)
            });
          }
          //  that.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
        }
      })
    } catch (ex) {

    }
  }
  getaldatafolder
  Getfolderdtaledrive(self) {
    let that = this;
    that.getaldata = [];
    try {
      var request = gapi.client.drive.files.list({
        q: "mimeType='application/vnd.google-apps.folder'",
        'maxResults': 1000
      });
      // that.ele.nativeElement.querySelector('.lds-roller').style.display = 'block';
      request.execute(function (resp) {
        if (!resp.error) {
          // that.getaldata = resp.items;
          that.getfolterroot(resp.items);


          if (that.getaldata != undefined) {
            that.getaldata.forEach(function (_data) {
              _data.embedLink = _data.iconLink.replace(/16/g, 128)
            });
          }
          // that.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
        }
      })
    } catch (ex) {

    }

  }
  getfolterroot(folder) {
    let that = this
    try {
      that.getaldata= _.filter(folder, function (o) { return  o.labels.trashed==false; });
      var request = gapi.client.drive.files.get({ 'fileId': 'root' });

      request.execute(function (resp) {

        that.isrootfolderid = [];
        if (that.getaldata)
          that.getaldata.forEach(function (_data) {
            _data.parents.forEach(function (_data1) {
              if (_data1.id == resp.id)
               // that.showfold = true
              // gData.labels.trashed
              that.isrootfolderid.push(_data)

            //  that.chRef.detectChanges();
            })
            // str.replace("Microsoft", "W3Schools");
          });


        // that.chRef.detectChanges();


      });
    }
    catch (ex) { }
  }

  getfile(fid, downloadUrl, alternateurl) {
    window.open(alternateurl)

    this.Getgoogledrive(this)
    // this.chRef.detectChanges()
  }

  getfileroot(that, filedata) {
    try {

      var request = gapi.client.drive.files.get({ 'fileId': 'root' });
      // that.isrootfileid=[]
      request.execute(function (resp) {

        that.isrootfileid = [];
        if (filedata)
          filedata.forEach(function (_data) {
            _data.parents.forEach(function (_data1) {
              if (_data1.id == resp.id)

                that.isrootfileid.push(_data)
              // that.showfiled = true;

              // that.chRef.detectChanges();
            })
            // str.replace("Microsoft", "W3Schools");
          });


        //  that.chRef.detectChanges();


      });
    }
    catch (ex) { }
  }

  retrieveAllFiles(that) {
    var retrievePageOfFiles = function (request, result) {
      request.execute(function (resp) {

        result = result.concat(resp.items);
        that.GoogledriveData = [];

        var nextPageToken = resp.nextPageToken;
        if (nextPageToken) {
          request = gapi.client.drive.files.list({
            'pageToken': nextPageToken,
            'maxResults': 1000,
            q: "trashed=false and mimeType!='application/vnd.google-apps.folder'"

          });
          retrievePageOfFiles(request, result);
        } else {

          that.GoogledriveData = result
          //that.showRectd = true
          
          // if(that.ElectronService.IS_Electron){
          //   that.chRef.detectChanges()
          // }
          //  if(that.GoogledriveData.length>5){
          //   that.showRectd=true
          //  }
          // alert(that.GoogledriveData.length)
          that.GoogledriveData.forEach(function (_data) {
            if (_data.mimeType == "application/vnd.google-apps.spreadsheet") {
              _data.thumbnailLink = "https://lh3.google.com/u/0/d/" + _data.id + "=w300-k-iv3"
              _data.embedLink = "https://lh3.google.com/u/0/d/" + _data.id + "=w300-k-iv3"
            }
            else {
              _data.embedLink = _data.iconLink.replace(/16/g, 128)
              //      }// str.replace("Microsoft", "W3Schools");
            }
          });
        }
      });
    }
    var initialRequest = gapi.client.drive.files.list({
      q: "trashed=false and mimeType!='application/vnd.google-apps.folder'",
      'maxResults': 1000

    });
    retrievePageOfFiles(initialRequest, []);
  }
  Getgoogledrive(that) {

    this.retrieveAllFiles(this)
    //  try{
    //    //this.getmyfile()
    //   var request = gapi.client.drive.files.list({

    //    'maxResults':1000
    //    // 'fields': "nextPageToken, files(id,name,webContentLink,webViewLink,mimeType,description,thumbnailLink,parents,iconLink,kind,sharingUser,shared,sharedWithMeTime)"
    //   });
    //   this.ele.nativeElement.querySelector('.lds-roller').style.display = 'block';
    //   request.execute(function (resp) {
    //     if (!resp.error) {

    //       that.godata = resp.items;
    //       that.GoogledriveData=resp.items;

    //       console.log(that.GoogledriveData)
    //      // that.getfileroot(that)
    //       that.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
    //       that.GoogledriveData.forEach(function (_data) {
    //         _data.embedLink=_data.iconLink.replace(/16/g,128)
    //        // str.replace("Microsoft", "W3Schools");
    //       });
    //       that.chRef.detectChanges()
    //     }
    //     else {
    //       //showErrorMessage("Error: " + resp.error.message);
    //     }
    //   })
    // }
    // catch(ex){

    // }
  }




  Againretrivefloderdata(folderId, name) {

    if (this.fdata.length > 1) {
      var r = _.findIndex(this.fdata, function (o) { return o.name == name; });


      if (r + 1 == this.fdata.length) {

      }
      else { this.fdata.splice((r + 1) - this.fdata.length) }

    }
    //  this.fdata.forEach(function(_value){
    //    if(_value.name== name){
    //      this.tems.push(_value)
    //    }

    //    })

    var AgainretrievePageOfChildren = function (request, result, that) {

      request.execute(function (resp) {
        result = result.concat(resp.items);
        that.googlechilderen = [];
        that.googlechilderen = result;
        that.foldersdata(that)
        var nextPageToken = resp.nextPageToken;
        if (nextPageToken) {
          request = gapi.client.drive.files.list({

            'pageToken': nextPageToken
          });
          AgainretrievePageOfChildren(request, result, this);
        } else {
          //  callback(result);
        }
      });
    }
    var initialRequest = gapi.client.drive.files.list({
      q: "'" + folderId + "' in parents",
      'maxResults': 1000,

    });

    AgainretrievePageOfChildren(initialRequest, [], this);


  }

  showfoler = false
  showfiles = false
  retrieveAllFilesInFolder(folderId, filename) {

    if (filename != undefined) {
      var fsfdata = {
        'id': folderId,
        'name': filename
      }
      this.fdata.push(fsfdata)
      if (this.fdata.length > 0) {
        try {
          for (var i = 0; i <= this.fdata.length; i++) {
            if (i < this.fdata.length && this.fdata.length > 1)
              if (this.fdata[i].name == this.fdata[i + 1].name) {
                this.fdata.splice(i + 1, 1)
              }
              else {

              }
          }
        }
        catch (ex) {

        }
      }


    }


    var retrievePageOfChildren = function (request, result, that) {

      request.execute(function (resp) {
        result = result.concat(resp.items);

        that.googlechilderen = result;
        that.foldersdata(that)

        var nextPageToken = resp.nextPageToken;
        if (nextPageToken) {
          request = gapi.client.drive.files.list({
            'pageToken': nextPageToken
          });
          retrievePageOfChildren(request, result, this);
        } else {
          //  callback(result);
        }
      });
    }
    var initialRequest = gapi.client.drive.files.list({
      q: "'" + folderId + "' in parents",
      'maxResults': 1000,

    });

    retrievePageOfChildren(initialRequest, [], this);


  }
  showGoogleDetails(popupParams, ev, width, height, gdata) {
    ev.stopPropagation();
    // this.myfile = _.filter(this.isrootfileid, function (o) {
    //   return o.thumbnailLink ==gdata.thumbnailLink;
    // });
    console.log(this.myfile)
    popupParams.loadDirective = GoogledetailsComponent;
    this.globalPopupPara = popupParams;
    this.globalPopupPara.showPopup = true;
    this.globalPopupPara.ev = ev;
    popupParams.height = height;
    popupParams.width = width;
    popupParams.arrowPos = 100;
    popupParams.direction = "left";
    if (ev.clientX > window.innerWidth * 0.6) {
      popupParams.direction = "right";
    }
    popupParams.bookDetals = true;
    this.selGoogleDetals = gdata;
    // this.chRef.detectChanges();
    // this.chRef.detach();

    //   var body = {'title': gdata.title, 'parents': [{ 'id': '1tXmDqTXWADDsFaVo-hf9aB9goky09vx5'}]
    // };
    // var request = gapi.client.drive.files.copy({
    //   'fileId': gdata.id,
    //   'resource': body
    // });
    // request.execute(function(resp) {
    //   console.log('Copy ID: ' + resp.id);
    // });
    // }
  }

  filterDriveData(popupParams, ev, width, height, arrposition) {
    ev.stopPropagation();

    popupParams.loadDirective = GoogledrivefilterdataComponent;
    this.globalPopupPara = popupParams;
    this.globalPopupPara.showPopup = true;
    this.globalPopupPara.ev = ev;

    if (this.isShowsharewithme) {

      if (this.SharingUser.length <= 4) {
        popupParams.height = this.SharingUser.length * 100
      }
      else if (this.SharingUser.length < 12) {
        popupParams.height = this.SharingUser.length * 60
      }
      else {
        popupParams.height = 600;
      }
    }
    else {
      popupParams.height = height;
    }

    popupParams.width = width;
    popupParams.arrowPos = arrposition;
    popupParams.direction = "top";

  }
  sharefile() {

    this.globalPopupPara = this.popupParams;
    this.globalPopupPara.showPopup = false;
    //this.chRef.detectChanges();
  }
  Createthefolder = true

  deletethefile(index, id) {

    let that = this
    this.globalPopupPara = this.popupParams;
    this.globalPopupPara.showPopup = false;
    var request = gapi.client.drive.files.trash({
      'fileId': id
    });

    request.execute(function (resp) {
      that.Getgoogledrive(that)
      that.Getfolderdtaledrive(that)
      that.Getfilesdtaledrive(that)
      if (that.fdata.length > 0) {

        var r = that.fdata.length - 1
        that.parentid = that.fdata[r].id
      }
      if (that.fdata.length > 0) {
        var r = that.fdata.length - 1
        that.parentid = that.fdata[r].id
        var name = that.fdata[r].name
        that.retrieveAllFilesInFolder(that.parentid, name)
      }
      //  that.chRef.detectChanges();

    });
  }
  // Createfolder(popupParams, ev, width, height, arrposition) {
  //   ev.stopPropagation();
  //   popupParams.loadDirective = NewgoogledriveComponent;
  //   this.globalPopupPara = popupParams;
  //   this.globalPopupPara.showPopup = true;
  //   this.globalPopupPara.ev = ev;
  //   popupParams.height = height;
  //   popupParams.width = width;
  //   popupParams.arrowPos = 50;
  //   popupParams.direction = "left";

  // }
  folderdata
  filedata
  foldersdata(that) {

    that.showfoler = false
    that.showfiles = false
    this.IsFolderdata = true;

    this.showfoler = _.find(this.googlechilderen, function (o) { return o.mimeType == "application/vnd.google-apps.folder" && o.labels.trashed == false; });
    this.folderdata = _.filter(this.googlechilderen, function (o) { return o.mimeType == "application/vnd.google-apps.folder" && o.labels.trashed == false; });
    this.showfiles = _.find(this.googlechilderen, function (o) { return o.mimeType != "application/vnd.google-apps.folder" && o.labels.trashed == false; });
    this.filedata = _.filter(this.googlechilderen, function (o) { return o.mimeType != "application/vnd.google-apps.folder" && o.labels.trashed == false; });
    this.googlechilderen.forEach(function (_data) {
      _data.embedLink = _data.iconLink.replace(/16/g, 128)
    })

    this.storedata = this.googlechilderen;
    this.IsFolderdata = true;
    //this.chRef.detectChanges();

  }
  updateRecentNextIcon(count) {
    var navigateBarsLength = this.Math.abs(this.Math.ceil(5 / (this.availableWidth / 300)))
    if (navigateBarsLength > 1) {
      this.hideRecentNext = true;
    } else {
      this.hideRecentNext = false;
    }
  }
  updateFolderNextIcon(count) {
    var navigateBarsLength = this.Math.abs(this.Math.ceil(count / (this.availableWidth / 180)))
    if (navigateBarsLength > 1) {
      this.hideFolderNext = true;
    } else {
      this.hideFolderNext = false;
    }
  }
  updateFileNextIcon(count) {
    var navigateBarsLength = this.Math.abs(this.Math.ceil(count / (this.availableWidth / 180)))
    if (navigateBarsLength > 1) {
      this.hideFileNext = true;
    } else {
      this.hideFileNext = false;
    }
  }

  updateShareNextIcon(count) {
    var navigateBarsLength = this.Math.abs(this.Math.ceil(count / (this.availableWidth / 180)))
    if (navigateBarsLength > 1) {
      this.hideShareNext = true;
    } else {
      this.hideShareNext = false;
    }
  }
  updateFolderdataNextIcon(count) {
    var navigateBarsLength = this.Math.abs(this.Math.ceil(count / (this.availableWidth / 180)))
    if (navigateBarsLength > 1) {
      this.hideFolderfNext = true;
    } else {
      this.hideFolderfNext = false;
    }
  }
  updateFiledataNextIcon(count) {

    var navigateBarsLength = this.Math.abs(this.Math.ceil(count / (this.availableWidth / 180)))
    if (navigateBarsLength > 1) {
      this.hideFilefNext = true;
    } else {
      this.hideFilefNext = false;
    }
  }
  updateFilterNextIcon(count) {

    var navigateBarsLength = this.Math.abs(this.Math.ceil(count / (this.availableWidth / 180)))
    if (navigateBarsLength > 1) {
      this.hideFilterNext = true;
    } else {
      this.hideFilterNext = false;
    }
  }
  displayGridViewForFolderfolder() {
    if (this.gridToggleIcon == 'icon-BottomButton') {
      this.gridToggleIcon = 'icon-TopButton';
      this.showFolderdatasGrid = true;
      this.hideFolderfNext = false
      this.hideFolderfPrev = true

    } else {
      this.gridToggleIcon = 'icon-BottomButton';
      this.showFolderdatasGrid = false;
    }
  }
  displayGridViewForRecents() {
    if (this.gridToggleIcon == 'icon-BottomButton') {
      this.gridToggleIcon = 'icon-TopButton';
      this.showRecentsGrid = true;

    } else {
      this.gridToggleIcon = 'icon-BottomButton';
      this.showRecentsGrid = false;
    }
  }


  displayGridViewForFolder() {
    if (this.gridToggleIcon == 'icon-BottomButton') {
      this.gridToggleIcon = 'icon-TopButton';
      this.showFoldersGrid = true;
      this.hideFolderNext = false;
      this.hideFolderPrev = true

    } else {
      this.gridToggleIcon = 'icon-BottomButton';
      this.showFoldersGrid = false;
      //this.hideFolderfNext=false;
    }
  }
  displayGridViewForFolderfile() {
    if (this.gridToggleIcon == 'icon-BottomButton') {
      this.gridToggleIcon = 'icon-TopButton';
      this.showFiledatasGrid = true;

    } else {
      this.gridToggleIcon = 'icon-BottomButton';
      this.showFiledatasGrid = false;
    }
  }
  displayGridViewForFilter() {
    if (this.gridToggleIcon == 'icon-BottomButton') {
      this.gridToggleIcon = 'icon-TopButton';
      this.showFiltersGrid = true;
      this.hideFilterNext = false;
      this.hideFilterPrev = true;

    } else {
      this.gridToggleIcon = 'icon-BottomButton';
      this.showFiltersGrid = false;
    }
  }
  displayGridViewForFile() {

    if (this.gridToggleIcon == 'icon-BottomButton') {
      this.gridToggleIcon = 'icon-TopButton';
      this.showFilesGrid = true;
      this.hideFileNext = false;
      this.hideFilePrev = true;
      // this.chRef.detectChanges()

    }
    else {
      this.gridToggleIcon = 'icon-BottomButton';
      this.showFilesGrid = false;
      this.hideFileNext = true;
      // this.chRef.detectChanges()
    }
  }
  displayGridViewForShare() {
    if (this.gridToggleIcon == 'icon-BottomButton') {
      this.gridToggleIcon = 'icon-TopButton';
      this.showSharesGrid = true;
      this.hideShareNext = false;
      this.hideSharePrev = true;
    } else {
      this.gridToggleIcon = 'icon-BottomButton';
      this.showSharesGrid = false;
    }
  }
  displayShareGridIcon() {
    if ((this.bottomThumbshare && this.bottomThumbshare.nativeElement.scrollWidth > this.bottomThumbshare.nativeElement.offsetWidth) || this.showSharesGrid == true) {
      return true;
    }
    else {
      return false;
    }
  }
  displayFileGridIcon() {
    if ((this.bottomThumbs2 && this.bottomThumbs2.nativeElement.scrollWidth > this.bottomThumbs2.nativeElement.offsetWidth) || this.showFilesGrid == true) {
      return true;
    }
    else {
      return false;
    }
  }
  displayFolderfolderGridIcon() {
    if ((this.bottomThumbsFolderdata && this.bottomThumbsFolderdata.nativeElement.scrollWidth > this.bottomThumbsFolderdata.nativeElement.offsetWidth) || this.showFolderdatasGrid == true) {
      return true;
    }
    else {
      return false;
    }
  }

  displayRecentGridIcon() {
    if ((this.panel && this.panel.nativeElement.scrollWidth > this.panel.nativeElement.offsetWidth) || this.showRecentsGrid == true) {
      return true;
    }
    else {
      return false;
    }
  }
  displayFolderGridIcon() {
    if ((this.bottomThumbs1 && this.bottomThumbs1.nativeElement.scrollWidth > this.bottomThumbs1.nativeElement.offsetWidth) || this.showFoldersGrid == true) {
      return true;
    }
    else {
      return false;
    }
  }
  displayFilterGridIcon() {
    if ((this.bottomThumbsfilter && this.bottomThumbsfilter.nativeElement.scrollWidth > this.bottomThumbsfilter.nativeElement.offsetWidth) || this.showFiltersGrid == true) {
      return true;
    }
    else {
      return false;
    }
  }
  displayFolderfileGridIcon() {
    if ((this.bottomThumbsFilesdata && this.bottomThumbsFilesdata.nativeElement.scrollWidth > this.bottomThumbsFilesdata.nativeElement.offsetWidth) || this.showFiledatasGrid == true) {
      return true;
    }
    else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shelf/googleDrive/googledrive/googledrive.component.ts